import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { color, flexCenter } from "../../styles/theme";

interface IDetailBtn {
	children: string;
	onClick?: any;
}

const Button = ({ children, onClick }: IDetailBtn) => {
	return (
		<>
			{!onClick ? (
				<DetailBtnSection onClick={onClick}>{children}</DetailBtnSection>
			) : (
				<DetailBtnSection onClick={onClick}>{children}</DetailBtnSection>
			)}
		</>
	);
};

const DetailBtnSection = styled.div`
	${flexCenter}
	align-items: center;
	width: 148.39px;
	height: 52.73px;
	background: #5b2980;
	border-radius: 0.4rem;
	color: ${color.white};
	font-size: 14px;
	letter-spacing: 2.5px;
	box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease 0s;
	cursor: pointer;

	&:hover {
		background-color: #2ea977;
		box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
		transform: translateY(-7px);
	}
`;

export default Button;
